export default __webpack_public_path__ + "static/media/world_map.e9469ef0.svg";